export default ["Black", "Blond", "Brown", "Cendre", "Grey", "Red", "Other"];
